<div class="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer" [class.tw:cursor-default]="disabled" [class.tw:opacity-50]="disabled" (click)="onBarClick($event, track)">
  <div class="tw:flex-1 tw:h-2 tw:bg-[#e0e0e0] tw:rounded tw:overflow-hidden" #track>
    <div class="tw:h-full tw:bg-[#6db33f] tw:rounded tw:transition-[width] tw:duration-150" [style.width]="fillWidth"></div>
  </div>
  <div class="tw:w-5 tw:h-5 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:text-[10px] tw:font-bold tw:flex-shrink-0" [ngClass]="isEmpty ? 'tw:bg-[#ccc] tw:text-[#999]' : 'tw:bg-[#6db33f] tw:text-white'">{{ dotLabel }}</div>
</div>
<div class="tw:flex tw:justify-between tw:text-[9px] tw:text-[#bbb] tw:mt-0.5">
  @for (label of labels; track label) {
    <span>{{ label }}</span>
  }
</div>
<div class="tw:text-[11px] tw:mt-1 tw:min-h-[14px]" [ngClass]="isEmpty ? 'tw:text-[#bbb] tw:font-normal' : 'tw:text-[#6db33f] tw:font-semibold'">{{ stepLabel }}</div>
